
    import { computed, defineComponent, onBeforeMount } from 'vue'

    import PostCategoryPreviewList from '@/app/components/common/posts/PostCategoryPreviewList.vue'

    import { useBreadcrumbsStore } from '@/app/stores/breadcrumbs'
    import { useCategoriesStore } from '@/app/stores/categories'

    import { useHeadful } from '@/common/composables/libs/headful'
    import { useI18n } from 'vue-i18n-composable'

    export default defineComponent({
        components: {
            PostCategoryPreviewList
        },
        setup () {
            const headful = useHeadful()
            const i18n = useI18n()
            const categoriesStore = useCategoriesStore()

            const entries = computed(() => categoriesStore.categories)

            onBeforeMount(async (): Promise<void> => {
                useBreadcrumbsStore().set([
                    { text: i18n.t('nav.blog.blog').toString(), to: { name: 'blog' } },
                    { text: i18n.t('nav.blog.categories').toString() }
                ])

                headful({
                    title: `${i18n.t('nav.blog.categories')} | ${i18n.t('meta.title')}`
                })

                await categoriesStore.load()
            })

            return {
                entries
            }
        }
    })
